export const shortEmail = (email: string): string =>
  typeof email === 'string' ? email.split('@')[0] : 'Unknown';
